	require('./bootstrap');
	require('./apiConfig');

	import Vue from 'vue';

	//Rutas del website
	import Router from './router.js';
	import {store} from './store/state-loader.js'
	import _ from 'lodash'

	import * as ToolFilters from './components/page/daniel/tools/filters';

	Vue.filter('msisdnToPhone', ToolFilters.msisdnToPhone);
	Vue.filter('mb2gb', ToolFilters.mb2gb);
	Vue.filter('altanFixLabel', ToolFilters.altanFixLabel);

	//Librerias globales
	import Library from './libs.js';
	Vue.use(Library);

	//Componentes del website
	import components from './components/components.js';
	import { mapActions } from 'vuex';
	Vue.use(components);

	window.Vue=Vue;

	//Instancia principal
	const app = new Vue({
		el: '#app',
		router:Router,

		data(){
			return{
				logged: true,
				catalogsIsLoaded: false,

				// == Paquetes ==
				planMovil: _.map([
					{
						id: 1,
						img: 'public/images/pages/home/cometa.png',
						nChars: 1,
						days: '3 días',
						gbs: '4 GB',
						hotspot: false,
						planName: 'COMETA',
						amount: 33,
						descr: `<p>2000 MB NORMAL<br />2000 MB VEL REDUCIDA<br />250 MINUTOS Y 125 SMS</p>`,
					},
				], pck => {
					pck.price = "$" + pck.amount.toFixed(2) + " MXN";
					return pck
				}),

				planMifi: [
					{
						id: 1,
						nChars: 2,
						days: '7 días',
						gbs: '10 GB',
						planName: 'SKY7D 10',
						amount: 95,
						price: '$95.00 MXN',
						descr: `<p>10 GB A LA MEJOR VELOCIDAD  DE LA RED POR 7 DIAS</p>`,
					}
				],

				planCasa: [
					{
						id: 1,
						nChars: 2,
						days: '30 días',
						gbs: '30 GB',
						planName: 'SKYHOME 30 5MB',
						amount: 150,
						price: '$150.00 MXN',
						descr: `<p>30 GB ALA MEJOR VELOCIDAD<br />+ 40 GB NOCTURNOS</p>`,
					}
				],
				// == fin paquetes ==

				// == Opciones de Carruseles de paquetes ==
				swPackOpts: {
					slidesPerView: 3,
					spaceBetween: 0,

					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					},

					breakpoints: {
						1300: {
							slidesPerView: 3,
						},
						768: {
							slidesPerView: 2,
						},
						1: {
							slidesPerView: 1,
						},
					}
				},
				// == fin opciones ==
			}
		},

		async beforeMount(){
			let openPayIsSandbox = false
			$(()=>{
				if(typeof OpenPay == 'function'){
					console.log('OpenPay loaded')
					
					// OPENPAY CONFIG
					if(!openPayIsSandbox){
						OpenPay.setId('mwr6piv9yeaxhyokzyoe');
						OpenPay.setApiKey('pk_5da92c19b9ae4caa8a6ae31175517685');
						// OpenPay.setSandboxMode( false ); // Si está en producción, esta función da problemas aunque se pase en false. (Bug de openpay)
					} else {
						// pagostesting@skycel.com.mx
						OpenPay.setId('mxu0adbbcsrqesskim9p');
						OpenPay.setApiKey('pk_1f33e0bcae3d46cd81f052698aabe414');
						OpenPay.setSandboxMode( true );
						alert('Is Sandbox!')
					}
				} else {
					console.error('No cargó el objeto OpenPay')
				}
			})
			this.catalogsIsLoaded = false
			await Promise.all([this.authLoadUp(), this.catalogosLoadUp(), this.OfertasPublicasRefresh(), this.cartReadFromLocal()])
			this.catalogsIsLoaded = true
		},

		methods: {
			...mapActions(['catalogosLoadUp', 'authLoadUp', 'OfertasPublicasRefresh', 'cartReadFromLocal']),

			noPaste(evt){
				// evt.preventDefault();
			},

			isNumber: function(evt) {
				evt = (evt) ? evt : window.event;
				var charCode = (evt.which) ? evt.which : evt.keyCode;
				if (charCode < 48 || charCode > 57) {
					evt.preventDefault();
				} else {
					return true;
				}
			}

		},

		store

	});
